import GameComplete from './GameComplete';

export default GameComplete;
